import React from 'react';
import { AuditLogs, Dynamo } from '../../../primary-record-types';
import useMedicalProfile from '../../../hooks/api/useMedicalProfile';
import { getIntl } from '../../../utils/intl';
import Text from '../../v2BaseComponents/Text';
import getName from '../../../utils/getName';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import getDateString from '../../../utils/getDateString';
import { getLogAvatarProps } from '../LogList/utils/getLogAvatarProps';
import LogCardAvatar from '../LogList/LogCard/LogCardAvatar';
import ProfilesProvider from '../LogList/LogCard/ProfilesProvider';

const intl = getIntl('screens.mainApp.homebase.homebaseScreen.logList.LogCard', {
    medicalProfile: 'Medical Profile: ',
    sentBy: 'Sent by',
});

export type ProfileMessageDetailsOwnProps = {
    auditLog: Dynamo.AuditLog & AuditLogs.ProfileMessageLogMetadata;
};

export type ProfileMessageDetailsProps = ProfileMessageDetailsOwnProps;

const ProfileMessageDetails: React.FC<ProfileMessageDetailsProps> = (props) => {
    const { isLoadingProfile, profile } = useMedicalProfile({
        medicalProfileId: props.auditLog.medicalProfileId || null,
    });

    const avatarProps = getLogAvatarProps(props.auditLog);

    const renderHeader = () => {
        if (!avatarProps) return null;

        return (
            <>
                <Text variant="h4">
                    <Text variant="h4">{intl('sentBy')}</Text>
                    <Text variant="bold-h4"> {avatarProps.name}</Text>
                </Text>
                <Stack horizontal justify="flex-start" align="center" space={4}>
                    <ProfilesProvider>{() => <LogCardAvatar {...avatarProps} />}</ProfilesProvider>
                    <Stack vertical fullWidth space={1}>
                        <Text variant="body-1">{avatarProps.name}</Text>
                        <Text variant="caption-1">{getDateString(props.auditLog.timestamp, 'date-time')}</Text>
                    </Stack>
                </Stack>
            </>
        );
    };

    const renderMedicalProfileContext = () => {
        if (isLoadingProfile || !profile || !props.auditLog.medicalProfileId) return null;
        return (
            <Text variant="body-2">
                <Text variant="body-2">{intl('medicalProfile')}</Text>
                <Text variant="body-2"> {getName(profile.contactDetails)}</Text>
            </Text>
        );
    };

    return (
        <Stack vertical fullWidth space={contentStackSpacing}>
            {renderHeader()}
            {renderMedicalProfileContext()}
            <Text variant="body-1">{props.auditLog.references.message}</Text>
        </Stack>
    );
};

export default React.memo(ProfileMessageDetails);
